import VariableValueCell, { isMultilineValue } from "./VariableValueCell";

export { isMultilineValue };
export default VariableValueCell;
